<template>
    <div>
        <PullRefresh v-model="isReFresh" @refresh="onRefresh">
            <List
                    style="height: 100%;padding: 5px 12px"
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    loading-text="拼命加载中..."
                    @load="onLoad"
                    :offset="50"
                    :immediate-check="true"
            >
                <MessageItem  v-for="item in notices" :key="item.id" :notice="item" @onUpdate="onUpdate"/>
            </List>
        </PullRefresh>
        <DetailPopup :show="show" type="detailPopup" @panel="switchPanel" :notice="selected"/>
    </div>
</template>

<script>
    import {PullRefresh,List} from "vant"
    import MessageItem from "./components/MessageItem"
    import DetailPopup from "./components/DetailPopup"
    import { mapGetters } from 'vuex';


    export default {
        components:{DetailPopup,MessageItem,PullRefresh,List},
        props: {},
        data(){
            return{
                notices:[],
                isReFresh:false,
                loading:false,
                finished:false,
                show:false,
                selected:{}
            }
        },
        computed:{
            ...mapGetters({user:'global/userInfo'})
        },
        created(){},
        mounted(){},
        methods:{
            switchPanel(type, data) {
                switch (type) {
                    case "detailPopup":
                        this.show = !this.show;
                        break;
                    default:
                        break;
                }
            },
            onUpdate(selected){
                //this.show=true;
                this.selected=selected
                this.read()
                this.$router.push('/message/alarm/'+this.selected.id)

            },
            read(){
                this.$http.tokiot.sys.pushMessage.read({idList:this.selected.id,readType:'WECHAT'})
                    .then(res=>{
                        if(res){
                            this.selected.state="READ"
                        }else{
                            this.$toast.fail(res.message)
                        }
                    })
            },
            onRefresh() {
                this.isReFresh = true;
                this.notices = [];
                this.onLoad(true);
            },
            onLoad(isPullRefresh) {
                this.$http.tokiot.sys.pushMessage.list({
                    userId:this.user.id,bizType:"ALARM",size:20, page: Math.ceil(this.notices.length / 20 + 1)
                }).then(res => {
                    if(res){
                        this.notices.push(...res.rows);
                        this.loading = false;
                        if (isPullRefresh) this.isReFresh = false;
                        if (this.notices.length >= res.total) {
                            this.finished = true;
                        }
                    }
                })
            },
        },
        watch:{}
    }
</script>

<style scoped>

</style>